import React, { useContext, useRef, useMemo } from 'react'
import { Note } from './note'
import { ProjectContext } from '../../../context/ProjectContext'

interface NotesProps {
  notes: any[]
}

export const Notes = ({ notes }: NotesProps) => {
  const {
    selectedNotes,
    setSelectedNotes,
    setSelectedFeedbacks,
    firstNoteSelected,
    setFirstNoteSelected,
    noteHover,
    setNoteHover,
    showDeleteNotesDialog,
    lastSelectedNote,
    setLastSelectedNote,
  } = useContext(ProjectContext)
  const notesRef = useRef(null)

  // Create refs for all notes
  const noteRefs = useMemo(
    () =>
      notes.reduce((acc, note) => {
        acc[note.id] = React.createRef()
        return acc
      }, {}),
    [notes]
  )

  const closeAll = () => {
    if (!showDeleteNotesDialog) {
      setSelectedNotes([])
      setFirstNoteSelected(null)
      setNoteHover(null)
      setLastSelectedNote(null)
    }
  }

  const handleNoteSelect = (noteId, event) => {
    event.stopPropagation()
    setSelectedFeedbacks([])
    console.log('event', event, noteId)
    console.log('event', event.metaKey, event.ctrlKey)
    if (event.ctrlKey || event.metaKey) {
      // Ctrl (or Cmd) key for multiple select
      setSelectedNotes((prevSelectedNotes) =>
        prevSelectedNotes.includes(noteId)
          ? prevSelectedNotes.filter((id) => id !== noteId)
          : [...prevSelectedNotes, noteId]
      )
      if (selectedNotes.length === 0) {
        setFirstNoteSelected(noteId)
        setNoteHover(noteId)
      }
      setLastSelectedNote(noteId)
    } else if (event.shiftKey) {
      // Shift key for range select
      if (selectedNotes.length === 0) {
        setSelectedNotes([noteId])
        setFirstNoteSelected(noteId)
        setNoteHover(noteId)
        setLastSelectedNote(noteId)
        return
      }
      const currentNoteIndex = notes.findIndex((note) => note.id === noteId)
      const firstNoteIndex = notes.findIndex((note) => note.id === firstNoteSelected)

      if (currentNoteIndex < firstNoteIndex) {
        setSelectedNotes(notes.slice(currentNoteIndex, firstNoteIndex + 1).map((note) => note.id))
      } else if (currentNoteIndex > firstNoteIndex) {
        setSelectedNotes(notes.slice(firstNoteIndex, currentNoteIndex + 1).map((note) => note.id))
      }
      setLastSelectedNote(noteId)
    } else {
      // Single select
      setSelectedNotes([noteId])
      setFirstNoteSelected(noteId)
      setNoteHover(noteId)
      setLastSelectedNote(noteId)
    }
  }

  return (
    <div
      className="w-full flex flex-wrap pt-5 relative"
      ref={notesRef}
      onClick={() => {
        setSelectedNotes([])
        setFirstNoteSelected(null)
        setNoteHover(null)
        setLastSelectedNote(null)
      }}
    >
      {notes.map((note) => (
        <Note
          key={note.id}
          note={note}
          selected={selectedNotes.includes(note.id)}
          handleNoteSelect={handleNoteSelect}
          noteHover={noteHover}
          setNoteHover={(noteId) => {
            setNoteHover(noteId)
            if (selectedNotes.includes(noteId)) setLastSelectedNote(noteId)
          }}
          onDeselect={closeAll}
          noteRef={noteRefs[note.id]}
          allNoteRefs={noteRefs}
          isLastSelected={lastSelectedNote === note.id}
        />
      ))}
    </div>
  )
}
